import React, { CSSProperties } from 'react';
import { useStoreState } from 'base/store';
import ListProductShowWholeRow from './ListProductShowWholeRow';
import ListProductShowDefault from './ListProductShowDefault';
import type { IProduct } from 'base/interfaces/product';
import type { IShowTag } from './ListProductImage';
import type { IQuickViewData } from './ListProductQuickView';
import type { PriceDirectionType } from '@base/snippets/ProductPriceV2';
import type { RateType } from '@base/lib/Rate';
import type { ThemePriceType } from '@base/lib/ThemePrice';
import type { TListType } from 'mod/product-list/interface';
import { IAddCartInstance } from '@base/product/useAddCart';
import { IElementTarget } from 'base/interfaces/common';
import { TDiscountStyle } from 'mod/product/interface'

// ELEMENT_LIST extra： flashsale 不默认展示
export const ELEMENT_LIST_ALL = ['name', 'rate', 'price', 'points', 'flashsale', 'underlinedPrice', 'addCart'];
export const ELEMENT_LIST = ['name', 'rate', 'price', 'underlinedPrice', 'points'];

export type ListProductProps = {
    moduleElementId?: string;
    addCart?: IAddCartInstance;
    aTarget?: IElementTarget;
    className?: string;
    style?: CSSProperties;
    spaceAroundPicture?: number;
    spaceBelowPicture?: number;
    product: IProduct;
    elements?: Array<typeof ELEMENT_LIST_ALL[number]>;
    imageSize: number;
    imgExtra?: React.ReactNode;
    showTag?: IShowTag; //是否展示标签
    isHoverChangeAsset?: boolean;   // pc hover 切换图片
    offTagShow?: TDiscountStyle; // 折扣标签 展示 '-' 还是 'OFF'
    productTag?: React.ReactNode | boolean; //自定义tag
    onQuickView?: (variantId: string) => void;
    onClickProd?: () => void;
    onAddToCart?: (itemData) => void;
    priceType?: ThemePriceType;
    priceDirection?: PriceDirectionType;
    rateType?: RateType;
    children?: React.ReactElement;
    listConfig?: {
        showType?: 'default' | 'wholeLine';
        flashSale?: {
            showType?: 'default' | 'simple'
        },
        listType?: TListType
    },
    'data-t-tar'?: string;
    'data-t-pos'?: string;
    'data-t-vid'?: string;
    'data-t-price'?: string;
};

const ListProduct = React.forwardRef<HTMLDivElement, ListProductProps>((props, ref) => {
    const {
        listConfig,
    } = props;

    const {
        listType,
        showType = 'default'
    } = listConfig || {}

    const { ua: { isPhone } } = useStoreState('rootStore')

    if (showType === 'wholeLine' || (isPhone && listType === 'flashsale')) {
        // 手机整行一个商品
        return (
            <ListProductShowWholeRow ref={ref} {...props} />
        )
    }

    return (
        <ListProductShowDefault ref={ref} {...props} />
    )
});

export default ListProduct;